"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _testing = _interopRequireDefault(require("@polkadot/keyring/testing"));

var _util = require("@polkadot/util");

var _accounts = _interopRequireDefault(require("./observable/accounts"));

var _addresses = _interopRequireDefault(require("./observable/addresses"));

var _development = _interopRequireDefault(require("./observable/development"));

var _defaults = require("./defaults");

// Copyright 2017-2019 @polkadot/ui-keyring authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
class Base {
  constructor() {
    this._accounts = void 0;
    this._addresses = void 0;
    this._keyring = void 0;
    this._prefix = void 0;
    this._accounts = _accounts.default;
    this._addresses = _addresses.default;
    this._keyring = undefined;
  }

  get accounts() {
    return this._accounts;
  }

  get addresses() {
    return this._addresses;
  }

  get keyring() {
    if (this._keyring) {
      return this._keyring;
    }

    throw new Error("Keyring should be initialised via 'loadAll' before use");
  }

  decodeAddress(key, ignoreChecksum) {
    return this.keyring.decodeAddress(key, ignoreChecksum);
  }

  encodeAddress(key) {
    return this.keyring.encodeAddress(key);
  }

  getPair(address) {
    return this.keyring.getPair(address);
  }

  getPairs() {
    return this.keyring.getPairs().filter(pair => _development.default.isDevelopment() || pair.getMeta().isTesting !== true);
  }

  isAvailable(_address) {
    const accountsValue = this.accounts.subject.getValue();
    const addressesValue = this.addresses.subject.getValue();
    const address = (0, _util.isString)(_address) ? _address : this.encodeAddress(_address);
    return !accountsValue[address] && !addressesValue[address];
  }

  isPassValid(password) {
    return password.length > 0 && password.length <= _defaults.MAX_PASS_LEN;
  }

  setAddressPrefix(prefix) {
    this._prefix = prefix;
  }

  setDevMode(isDevelopment) {
    _development.default.set(isDevelopment);
  }

  initKeyring(options) {
    const keyring = (0, _testing.default)((0, _objectSpread2.default)({
      addressPrefix: this._prefix
    }, options), true);

    if ((0, _util.isBoolean)(options.isDevelopment)) {
      this.setDevMode(options.isDevelopment);
    }

    this._keyring = keyring;
    this.addAccountPairs();
  }

  addAccountPairs() {
    this.keyring.getPairs().forEach(pair => {
      const address = pair.address();
      this.accounts.add(address, {
        address,
        meta: pair.getMeta()
      });
    });
  }

  addTimestamp(pair) {
    if (!pair.getMeta().whenCreated) {
      pair.setMeta({
        whenCreated: Date.now()
      });
    }
  }

}

exports.default = Base;